<ng-container *ngIf="control">
  <ng-container
    *ngIf="isInputType && shouldUseAutoExpand(); then autoExpandContent; else (isInputType ? inputContent : textAreaContent)"></ng-container>
</ng-container>
<ng-template #inputContent>
  <div [ngClass]="{'has-prefix': !!prefix, 'has-label': !!labelTranslationKey && !disabled}"
    class="position-relative text-input-wrapper">
    <input #inputElement (blur)="handleOnBlur($event)" (focus)="handleOnFocus($event)"
      [autocorrect]="isUrlInputType ? 'off' : 'on'" [attr.inputmode]="inputMode" (keyup.enter)="handleOnEnter()"
      [class]="'rosie-form-control form-control ' + customClass" [dataHook]="labelTranslationKey"
      [formControl]="control" [id]="id" [min]="min"
      [ngClass]="{'has-value': hasValue, 'has-tooltip': hasTooltip, 'disabled': disabled }"
      [ngStyle]="{'padding-left': inputPaddingLeft}" [type]="inputType" [disabled]="disabled"
      placeholder="{{ placeholderTranslationKey | translate }}" />
    <label #prefixContainer *ngIf="prefix" [ngClass]="{'always-display': alwaysDisplayPrefix}" class="prefix">{{
      prefix
      }}</label>
    <label *ngIf="labelTranslationKey && !disabled" [for]="id" [ngClass]="'rosie-form-control-label'">
      {{ labelTranslationKey | translate }}
    </label>
    <span *ngIf="hasTooltip" [ngbTooltip]="tooltip" class="icon tooltip-icon position-absolute"
      tooltipClass="tooltip-wrapper status-tooltip"><img src="assets/images/question.svg" /></span>
  </div>
</ng-template>
<ng-template #autoExpandContent>
  <div [ngClass]="{'has-prefix': !!prefix, 'has-label': !!labelTranslationKey && !disabled}"
    class="position-relative text-input-wrapper auto-expand-wrapper {{ customClass }}">
    <textarea #autoExpandInput (blur)="handleOnBlur($event)" (focus)="handleOnFocus($event)" (input)="handleInput()"
      (keydown.enter)="handleOnEnter($event)" [autocorrect]="isUrlInputType ? 'off' : 'on'" [attr.inputmode]="inputMode"
      [class]="'rosie-form-control form-control auto-expand-input'" [dataHook]="labelTranslationKey"
      [formControl]="control" [id]="id"
      [ngClass]="{'has-value': hasValue, 'has-tooltip': hasTooltip, 'disabled': disabled }"
      [ngStyle]="{'padding-left': inputPaddingLeft}" [disabled]="disabled"
      placeholder="{{ placeholderTranslationKey | translate }}" rows="1"></textarea>
    <label #prefixContainer *ngIf="prefix" [ngClass]="{'always-display': alwaysDisplayPrefix}" class="prefix">{{
      prefix
      }}</label>
    <label *ngIf="labelTranslationKey && !disabled" [for]="id" [ngClass]="'rosie-form-control-label'">
      {{ labelTranslationKey | translate }}
    </label>
    <span *ngIf="hasTooltip" [ngbTooltip]="tooltip" class="icon tooltip-icon position-absolute"
      tooltipClass="tooltip-wrapper status-tooltip"><img src="assets/images/question.svg" /></span>
  </div>
</ng-template>
<ng-template #textAreaContent>
  <div class="rosie-textarea-wrapper"
    [ngClass]="{'has-label': labelTranslationKey, 'with-warning': control?.invalid && control?.touched, 'has-value': control?.value}">
    <textarea #textareaElement (blur)="handleOnBlur($event)" (focus)="handleOnFocus($event)"
      [ngClass]="{'has-label': labelTranslationKey, 'has-value': control?.value}"
      [class]="'rosie-form-control form-control rosie-textarea'" [dataHook]="labelTranslationKey"
      [formControl]="control" [id]="id" [rows]="rows" [attr.inputmode]="inputMode"
      placeholder="{{ placeholderTranslationKey | translate }}">
    </textarea>
    <label *ngIf="labelTranslationKey" [for]="id" [ngClass]="'rosie-form-control-label'">
      {{ labelTranslationKey | translate }}
    </label>
    <span *ngIf="maxLength" class="character-counter" [ngClass]="{'invalid': control.value?.length > maxLength}">{{
      control.value?.length || 0 }} / {{ maxLength }}</span>
  </div>
</ng-template>
<rosie-validation-error [show]="control?.errors?.unicode && control?.touched"
  [translationKey]="'COMMON.VALIDATION.UNICODE'"
  [translationAttributes]="{value: (labelTranslationKey | translate) }"></rosie-validation-error>